// extracted by mini-css-extract-plugin
export var socialIcon = "styles-module--socialIcon--BZzZq";